module.exports = __webpack_public_path__ + "static/media/geotrust.76fe83de.svg";